import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-header-right-content',
    templateUrl: './eui-card-header-right-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderRightContentComponent {

    @HostBinding('class') string = 'eui-card-header__right-content';

    constructor( ) {
    }
}
